import React from 'react';
import MaleIcon from '../MaleIcon'
import FemaleIcon from '../FemaleIcon'
import Icofont from 'react-icofont';
import { MaxIcon } from '../Tool';

export default function User({ item, noborder }) {
    return (<div style={{cursor: "default"}}>
        <div style={{ fontWeight: "500" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {item.genderID && <span>
                        {(item.genderID == 1) ? <MaleIcon /> : <FemaleIcon />}
                    </span>}
                    {item.lastname} {item.firstname} {item.patronymic}
                </div>
                {!noborder && <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>}
            </div>
        </div>
        {(item.email || item.phone) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
            {(item.email) && <span><Icofont icon="mail" /> {item.email}</span>}
            {(item.phone) && <span style={{ paddingLeft: "5px" }}><Icofont icon="phone" />+{item.phone}</span>}
            {(item.tgchatid) && <span style={{ paddingLeft: "5px", color: "#4096ff" }}><Icofont icon="telegram" /></span>}
            {(item.vk) && <a target="_blank" href={"https://vk.com/id"+item.vk} style={{ paddingLeft: "5px", color: "#4096ff" }}><Icofont icon="vk" /></a>}
            {(item.maxchatid) && <span style={{ paddingLeft: "5px"}}><MaxIcon width={11} height={11} color="#4096ff" /></span>}
        </div>}
    </div>)
}